export default __webpack_public_path__ + "static/media/image-cover.f7c130ac.jpg";